import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../locaties/AllLocaties.css';

function AllLocaties() {
  const [locaties, setLocaties] = useState([]);
  const [zoekterm, setZoekterm] = useState('');
  const [filteredLocaties, setFilteredLocaties] = useState([]);

  axios.defaults.withCredentials = true;
  const token = sessionStorage.getItem('jwtToken');

  const fetchLocaties = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/location/alllocationsfull`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLocaties(response.data.data || []);
    } catch (error) {
      console.error('Fout bij ophalen locaties:', error);
      alert('Fout bij ophalen van locaties.');
    }
  }, [token]);

  useEffect(() => {
    fetchLocaties();
  }, [fetchLocaties]);

  const handleDelete = async (id) => {
    if (!window.confirm('Weet je zeker dat je deze locatie wilt verwijderen?')) return;

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/location/deleteLocation/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      await fetchLocaties();
      alert(response.data?.message || 'Locatie succesvol verwijderd!');
    } catch (error) {
      console.error('Fout bij verwijderen locatie:', error);

      const status = error.response?.status;
      const data = error.response?.data;

      if (status === 409) {
        const students = data?.details?.students ?? 0;
        const teachers = data?.details?.teachers ?? 0;
        const parents = data?.details?.parents ?? 0;

        alert(
          `${data?.message || 'Deze locatie kan niet worden verwijderd.'}\n\n` +
          `Gekoppelde actieve records:\n` +
          `- Leerlingen: ${students}\n` +
          `- Docenten: ${teachers}\n` +
          `- Ouders: ${parents}`
        );
        return;
      }

      if (status === 404) {
        alert(data?.message || 'Locatie niet gevonden of al verwijderd.');
        return;
      }

      alert(data?.message || 'Er is een fout opgetreden bij het verwijderen van de locatie.');
    }
  };

  useEffect(() => {
    const filtered = locaties.filter((locatie) =>
      (locatie.location_name || '').toLowerCase().includes(zoekterm.toLowerCase())
    );
    setFilteredLocaties(filtered);
  }, [zoekterm, locaties]);

  const ActionButtons = ({ locatie }) => (
    <div className="d-flex flex-wrap gap-1">
      <Link
        to={`/locatie/edit/${locatie.location_id}`}
        className="btn btn-sm btn-warning rounded-0"
        style={{ fontSize: '10px', padding: '2px 5px' }}
        onClick={(e) => e.stopPropagation()}
      >
        Bewerk
      </Link>
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(locatie.location_id);
        }}
        className="btn btn-sm btn-danger rounded-0"
        style={{ fontSize: '10px', padding: '2px 5px' }}
      >
        Verwijder
      </button>
    </div>
  );

  return (
    <div className="all-locaties">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1>Overzicht Van Alle Locaties</h1>
        <Link to="/locatie/nieuw" className="btn btn-success">
          <i className="bi bi-plus-circle me-2"></i>Nieuwe locatie
        </Link>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="form-control rounded-0"
          placeholder="Zoek op locatie naam"
          value={zoekterm}
          onChange={(e) => setZoekterm(e.target.value)}
        />
      </div>

      <div className="table-responsive d-none d-md-block">
        <table className="table table-striped table-bordered">
          <thead className="table-light">
            <tr>
              <th>Naam Locatie</th>
              <th>Contact Voornaam</th>
              <th>Contact Achternaam</th>
              <th>Contact Mobiel</th>
              <th>Email</th>
              <th>Telefoon</th>
              <th>Adres</th>
              <th>Acties</th>
            </tr>
          </thead>
          <tbody>
            {filteredLocaties.map((locatie) => (
              <tr key={locatie.location_id}>
                <td>{locatie.location_name}</td>
                <td>{locatie.contact_firstname}</td>
                <td>{locatie.contact_lastname}</td>
                <td>{locatie.contact_mobile}</td>
                <td>{locatie.email}</td>
                <td>{locatie.phone}</td>
                <td>{locatie.address}</td>
                <td><ActionButtons locatie={locatie} /></td>
              </tr>
            ))}
            {filteredLocaties.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center">Geen locaties gevonden.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-md-none locatie-cards">
        {filteredLocaties.length === 0 && (
          <p className="text-center text-muted mt-3">Geen locaties gevonden.</p>
        )}
        {filteredLocaties.map((locatie) => (
          <div key={locatie.location_id} className="locatie-card">
            <div className="locatie-card-header">
              <div className="locatie-card-name">{locatie.location_name}</div>
              {locatie.phone && (
                <a
                  href={`tel:${locatie.phone}`}
                  className="btn btn-sm btn-outline-secondary rounded-circle"
                  style={{
                    width: 34,
                    height: 34,
                    padding: 0,
                    lineHeight: '32px',
                    textAlign: 'center',
                    flexShrink: 0
                  }}
                  onClick={(e) => e.stopPropagation()}
                  title={locatie.phone}
                >
                  <i className="bi bi-telephone" style={{ fontSize: '13px' }}></i>
                </a>
              )}
            </div>

            <div className="locatie-card-meta">
              {(locatie.contact_firstname || locatie.contact_lastname) && (
                <span>
                  <i className="bi bi-person me-1"></i>
                  {locatie.contact_firstname} {locatie.contact_lastname}
                </span>
              )}
              {locatie.email && (
                <span>
                  <i className="bi bi-envelope me-1"></i>{locatie.email}
                </span>
              )}
              {locatie.address && (
                <span>
                  <i className="bi bi-geo-alt me-1"></i>{locatie.address}
                </span>
              )}
              {locatie.contact_mobile && (
                <span>
                  <i className="bi bi-phone me-1"></i>{locatie.contact_mobile}
                </span>
              )}
            </div>

            <div className="locatie-card-actions">
              <ActionButtons locatie={locatie} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllLocaties;